import React, { useEffect } from 'react';

import { useLocation } from '@reach/router';
import { Button } from 'src/components/Button';
import { Modal } from 'src/components/Modal';
import { Text } from 'src/components/Text';
import routes from 'src/constants/routes';
import { useModalContext } from 'src/contexts/ModalContext';

import * as modalTTCStyles from './modalttc.module.css';

export const ModalTTC = () => {
  const location = useLocation();
  const { close } = useModalContext();

  useEffect(() => {
    if (location.pathname === routes.tntProgram) {
      close();
    }
  }, [close, location.pathname]);

  return (
    <Modal
      title="Točno i tečno čitanje"
      DescriptionComponent={
        <>
          <div className={modalTTCStyles.bodyContainer}>
            <div>
              <Text type="body2">
                Program točnog i tečnog čitanja osmišljen za djecu koja žele napredovati.
              </Text>
            </div>
            <div>
              <Text type="body2">
                Saznajte sve o programu i kako se prijaviti.
              </Text>
            </div>
            <div>
              <Text type="body2">
                Akcija vrijedi od <b>4. do 17. svibnja</b>.
              </Text>
            </div>
          </div>
          <div>
            <Button
              type="primary"
              sizes={{ large: 'medium', medium: 'medium', small: 'medium', xsmall: 'small' }}
              mode={{
                type: 'link',
                to: routes.tntProgram,
              }}
              label="SAZNAJTE VIŠE"
            />
          </div>
        </>
      }
      hasParrot
    />
  );
};
